import { Col, Layout, Row, Space } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Logo from "assets/logo.icon.png";

import styles from "./Header.module.less";
import UserMenu from "../UserMenu";
import LangSelector from "../LangSelector";

function Header(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Layout.Header className={styles.header}>
      <Row justify="space-between" align="middle">
        <Col>
          <Link className={styles.logo} to="/">
            <img src={Logo} alt="" />
            <p>{t("app_title")}</p>
          </Link>
        </Col>
        <Col>
          <Space size="large">
            <LangSelector />
            <UserMenu />
          </Space>
        </Col>
      </Row>
    </Layout.Header>
  );
}

export default Header;
